import React, { useEffect, useRef, useState } from "react";
import TNButton from "../../reusable-components/TNButton";
import {
  ButtonHTMLType,
  ButtonShape,
  ButtonSize,
} from "../../enums/ButtonAttributesEnums";
import {
  ButtonGroupStyles,
  CreateJobViewConstants,
  customerColumns,
  FILTER_FIELD_NAMES_TO_COUNT,
  JobData,
} from "../CreateJob/constants";
import CustomTableWithPagination from "../../reusable-components/CustomTable";
import CreateJobServices from "../../services/createJob.services";
import Loading from "../../Common/Loading";
import styles from "./CreateJobListing.module.scss";
import Form from "../Form";
import InputField from "../../reusable-components/TNInputField";
import { InputfieldTypes } from "../../enums/InputFieldAttributesEnums";
import Search from "../../assets/images/search-button.svg";
import FilterIcon from "../../assets/images/filterIcon.svg";
import ListViewIcon from "../../assets/images/listViewIcon.svg";
import KanBanViewIcon from "../../assets/images/kanBanIcon.svg";
import MapViewIcon from "../../assets/images/mapViewIcon.svg";
import clsx from "clsx";
import ConditionalRender from "../../reusable-components/ConditionalRender";
import { ViewListingTypes } from "../../enums/ViewListingTypes";
import { message, Switch } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import JobListMapView from "./JobListMapView";
import { generatePath } from "react-router";
import { appRoutes } from "../../constants/appRoutes";
import { useWrapperContext } from "../../context/WrapperContext";
import RolesServices from "../../services/roles.services";
import { UserRoles } from "../../enums/UserRolesEnum";
import { JobStepNumber } from "../../Utilities/jobUtil";
import emptyIcon from "../../assets/images/noDataFound.svg";
import { useMaterials } from "../../context/materialListingContext";
import { useTruckDetailContext } from "../../context/TruckDetailsContext";
import { useDebounce } from "@uidotdev/usehooks";
import moment from "moment";
import { TimeTypes } from "../../enums/dateTimeFormat";
import { jobStatus } from "./CreateJobView/constants";
import CrmFilterDrawer from "./CrmFilterDrawer";
import { boolean } from "yup";
import { storageKeys } from "../../constants/storageKeys";
import JobDatabaseService from "../../services/jobDatabase.service";
import { ApiResponse } from "../../enums/ApiResponse";
import TNLoader from "../../reusable-components/TNLoader";
import { TableDefaults } from "../../enums/TableEnums";
import { countFiltersApplied } from "../../utils/countAppliedFilters";

const JobView = () => {
  const isMountRef = useRef<boolean>(true);
  const location = useLocation();
  const { setPrevRecord } = useWrapperContext();
  const { resetTruckMaterial } = useMaterials();
  const { resetTruckDetails } = useTruckDetailContext();
  const navigate = useHistory();
  const { LIST, KANBAN, MAP } = ViewListingTypes;
  const { GetPaginationDefaultMeta } = JobDatabaseService();
  const { FetchAllJob } = CreateJobServices();
  const [pageSizeChanged, setPageSizeChanged] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeView, setActiveView] = useState(LIST);
  const [pageSize, setPageSize] = useState<number | null>(() => {
    const raw = sessionStorage.getItem(storageKeys.CRM_PAGESIZE);
    return raw !== null && raw !== "" ? Number(raw) : null;
  });
  const [showBlocked, setShowBlocked] = useState<boolean>(
    sessionStorage?.getItem(storageKeys.CRM_SHOW_BLOCKED) ===
      CreateJobViewConstants.TRUE_STRING,
  );
  // Add filter states
  const [filters, setFilters] = useState({
    search: "",
    salesPerson: undefined,
    customerName: undefined,
    jobStatus: undefined,
    fromDate: undefined,
    toDate: undefined,
  });
  // User role handling
  const userDetails = localStorage.getItem("userDetails");
  const userDetailsJson = JSON.parse(userDetails);
  const userRoleInfo = userDetailsJson?.["userRoleInfo"];
  const userRoleProfileInfo = userDetailsJson?.["userProfile"];

  const { data: defaultData, isFetching: gettingDefaults } =
    GetPaginationDefaultMeta();
  const { FetchUserRoleDetails } = RolesServices();
  const { data: roleDetails } = FetchUserRoleDetails(userRoleInfo);
  const {
    data: jobListingData,
    isLoading,
    isFetching,
    isRefetching,
    refetch: refetchAllJobs,
    isSuccess: listFetchedSuccess,
  } = FetchAllJob(
    {
      page: currentPage,
      perPage: pageSize,
      search: filters?.search,
      jobStatus: filters?.jobStatus,
      salesPersonId: filters?.salesPerson,
      companyId: filters?.customerName,
      fromDate: filters?.fromDate,
      toDate: filters?.toDate,
      isBlocked: showBlocked,
    },
    pageSizeChanged,
    !location.hash?.includes(ViewListingTypes.MAP) &&
      !!sessionStorage.getItem(storageKeys.CRM_PAGESIZE) &&
      pageSize !== null,
  );
  const [searchValue, setSearchValue] = useState("");
  const [searchInputValue, setSearchInputValue] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [clearAllFilterButton, setClearAllFilterButton] =
    useState<boolean>(false);
  const debounced = useDebounce(searchInputValue, 400);
  const filterCount = countFiltersApplied(filters, FILTER_FIELD_NAMES_TO_COUNT);

  const handlePaginationPageSize = (size: number) => {
    setPageSize(size);
    setPageSizeChanged(true);
    setCurrentPage(1);
    try {
      sessionStorage.setItem(storageKeys.CRM_PAGESIZE, size);
    } catch (err) {
      console.error("Err", err);
    }
  };
  const handleCurrentPage = (page: number) => {
    setCurrentPage(page);
  };
  const handlePagination = (page: number) => handleCurrentPage(page);
  // Format job data
  const formattedJobData = jobListingData?.data;
  const totalEntries = jobListingData?.meta?.totalRecords;
  // Search handlers
  const handleSearch = (val?: string) => {
    const searchVal = val || "";
    setSearchValue(searchVal);
    setSearchInputValue(searchVal);
  };

  const handleSearchClick = (currentSearchValue: string) => {
    handleSearch(currentSearchValue);
  };

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    const value = event.target.value;
    if (!value) {
      handleSearch("");
    }
  };

  const noActionDropFields = !!userRoleProfileInfo
    ? roleDetails?.[0]?.otherData?.[1]?.multiPannel?.[0]?.selectedOptions?.includes(
        "Edit",
      )
    : true;

  // Other handlers
  const handleViewNavigate = (row?: any) => {
    navigate.push(
      `/app/view-trucking-material/${row?.id}${window.location?.hash}`,
    );
  };

  const handleEditNavigate = (record: any) => {
    if (!!record?.isBlocked) {
      return;
    }
    if (noActionDropFields) {
      if (record?.stageId !== jobStatus.dispatchApproved) {
        setPrevRecord(record);
        resetTruckDetails();
        resetTruckMaterial();
        JobStepNumber[record?.stageId] &&
          navigate.push(
            `/app/update-trucking-material/${record?.id}#${ViewListingTypes.LIST}`,
            {
              jobSpecificsData: record,
              edit: true,
              jobData: formattedJobData,
              step: JobStepNumber[record?.stageId],
              from: location,
            },
          );
      }
    } else {
      message.error(CreateJobViewConstants.EDIT_ACCESS_REQUIRED);
    }
  };

  const handleOpenDrawer = () => {
    setIsOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsOpen(false);
  };

  // Columns configuration with sales person rendering
  const customerColumnsDataCols = customerColumns({
    handleViewNavigate,
  });
  const handleAddJob = () => {
    navigate.push(`/app/add-trucking-material${window.location?.hash}`, {
      from: location,
    });
    resetTruckMaterial();
    resetTruckDetails();
  };

  const handleViewToogle = (view: ViewListingTypes) => {
    window.location.hash = view;
    setActiveView(view);
  };

  useEffect(() => {
    setActiveView(window.location?.hash?.slice(1));
  }, [window.location?.hash]);

  useEffect(() => {
    if (!window.location.hash) {
      window.location.hash = ViewListingTypes.LIST;
    }
  }, [window.location.pathname, window.location.hash]);

  const handleGetFilteredResults = (
    jobStatus,
    customerAccount,
    salesPerson,
    dateRange,
  ) => {
    setCurrentPage(1);
    setFilters({
      ...filters,
      jobStatus: jobStatus,
      customerName: customerAccount,
      salesPerson: salesPerson,
      ...(!!dateRange?.[0]
        ? {
            fromDate: moment(dateRange?.[0]).startOf(TimeTypes.DAY).valueOf(),
            toDate: moment(dateRange?.[1]).endOf(TimeTypes.DAY).valueOf(),
          }
        : {
            fromDate: undefined,
            toDate: undefined,
          }),
    });
    handleCloseDrawer();
  };

  const handleClearFilters = () => {
    setFilters({
      ...filters,
      jobStatus: undefined,
      customerName: undefined,
      salesPerson: undefined,
      fromDate: undefined,
      toDate: undefined,
    });
    setCurrentPage(1);
    handleEnableClearAllFilterButton();
  };

  const handleFilterOptionClear = (fieldName: string) => {
    setFilters({
      ...filters,
      [fieldName]: undefined,
    });
  };

  const handleShowBlocked = (checked: boolean) => {
    setShowBlocked(checked);
  };

  const handleEnableClearAllFilterButton = () => {
    setClearAllFilterButton(true);
  };

  const handleDisableClearAllFilterButton = () => {
    setClearAllFilterButton(false);
  };

  useEffect(() => {
    setFilters({
      ...filters,
      search: debounced,
    });
    setCurrentPage(1);
  }, [debounced]);

  useEffect(() => {
    if (isMountRef.current) {
      isMountRef.current = false;
      return;
    }
    if (!location.hash?.includes(ViewListingTypes.MAP) && pageSize !== null) {
      refetchAllJobs();
    }
    if (showBlocked) {
      sessionStorage.setItem(storageKeys.CRM_SHOW_BLOCKED, showBlocked);
    } else {
      sessionStorage.removeItem(storageKeys.CRM_SHOW_BLOCKED);
    }
  }, [showBlocked, filters, currentPage, pageSize]);

  useEffect(() => {
    setCurrentPage(1);
  }, [pageSize, showBlocked]);

  useEffect(() => {
    if (defaultData?.message && defaultData?.message === ApiResponse.SUCCESS) {
      setPageSize(defaultData?.data?.truckingAndMaterialDefaultPageSize);
    }
  }, [defaultData]);

  useEffect(() => {
    if (listFetchedSuccess && pageSizeChanged) {
      setPageSizeChanged(false);
    }
  }, [listFetchedSuccess && pageSizeChanged]);

  return (
    <>
      <TNLoader
        isLoading={isLoading || isRefetching || isFetching || gettingDefaults}
      />
      <div className={styles.headerInterface}>
        <Form
          defaultValues={{
            jobStatusFilter: filters?.jobStatus,
            customerNameFilter: filters?.customerName,
            salesPersonFilter: filters?.salesPerson,
            dateRangeFilter: [filters?.fromDate, filters.toDate],
          }}
        >
          {() => (
            <CrmFilterDrawer
              isOpen={isOpen}
              handleClose={handleCloseDrawer}
              filterValue={filters}
              setFilterValue={setFilters}
              handleClearFilter={handleClearFilters}
              handleApply={handleGetFilteredResults}
              clearAllFilterButton={clearAllFilterButton}
              handleDisableClearAllFilterButton={
                handleDisableClearAllFilterButton
              }
            />
          )}
        </Form>
        <div className={styles.leftContainer}>
          <Form>
            {({ watch }) => {
              const currentSearchValue = watch("jobSearch");
              const addOnAfter = (
                <TNButton
                  shape={ButtonShape.DEFAULT}
                  size={ButtonSize.LARGE}
                  block
                  text={
                    <img src={Search} width={"16"} height={"20"} alt="search" />
                  }
                  onClick={() => handleSearchClick(currentSearchValue)}
                />
              );
              return (
                <InputField
                  type={InputfieldTypes.TEXT}
                  name={"jobSearch"}
                  placeholder={"Search"}
                  addonAfter={addOnAfter}
                  onBlur={handleBlur}
                  value={searchInputValue}
                  onChange={(e) => {
                    setSearchInputValue(e.target.value);
                    if (!e.target.value) {
                      handleSearch("");
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleSearch(currentSearchValue);
                    }
                  }}
                />
              );
            }}
          </Form>
          <TNButton
            filterButton
            shape={ButtonShape.DEFAULT}
            size={ButtonSize.LARGE}
            badgeCount={filterCount}
            text="Filter"
            afterTitle={true}
            icon={<img src={FilterIcon} />}
            onClick={handleOpenDrawer}
          />
          {filterCount > 0 && (
            <TNButton
              clearFilterButton
              shape={ButtonShape.ROUND}
              size={ButtonSize.MEDIUM}
              text="Clear All"
              onClick={handleClearFilters}
            />
          )}
        </div>
        <div className={styles.rightContainer}>
          <div className={styles.blockedToggle}>
            <span>{CreateJobViewConstants.SHOW_BLOCKED}</span>
            <Switch checked={showBlocked} onClick={handleShowBlocked} />
          </div>
          <TNButton
            shape={ButtonShape.DEFAULT}
            size={ButtonSize.LARGE}
            text={CreateJobViewConstants.ADD_JOB_BTN_TEXT}
            onClick={() => handleAddJob()}
            disabled={!noActionDropFields}
          />
          <div className={styles.innerViewWrapper}>
            <TNButton
              className={clsx(styles.hoverButtonGrp, {
                [styles.selected]: activeView === LIST,
              })}
              customStyles={ButtonGroupStyles}
              shape={ButtonShape.DEFAULT}
              size={ButtonSize.LARGE}
              text={
                <div className={styles.filterWrapper}>
                  <img src={ListViewIcon} />
                </div>
              }
              onClick={() => handleViewToogle(LIST)}
            />
            <TNButton
              className={clsx(styles.hoverButtonGrp, {
                [styles.selected]: activeView === MAP,
              })}
              customStyles={ButtonGroupStyles}
              shape={ButtonShape.DEFAULT}
              size={ButtonSize.LARGE}
              text={
                <div className={styles.filterWrapper}>
                  <img src={MapViewIcon} />
                </div>
              }
              onClick={() => handleViewToogle(MAP)}
            />
          </div>
        </div>
      </div>
      <div className={styles.tableInterface}>
        <ConditionalRender visible={activeView === LIST}>
          <ConditionalRender
            visible={formattedJobData?.length > 0}
            fallback={
              !isLoading &&
              !isRefetching && (
                <div className={styles.emptyContainer}>
                  <img src={emptyIcon} width={40} height={45} />
                  <p>
                    {searchValue
                      ? CreateJobViewConstants.NO_SEARCH_DATA
                      : CreateJobViewConstants.NO_JOB_DATA}
                  </p>
                </div>
              )
            }
          >
            <CustomTableWithPagination<JobData>
              key={`table-${pageSize}`}
              data={formattedJobData}
              columns={customerColumnsDataCols}
              bordered={false}
              isClickableTable
              handleSelectedRow={handleEditNavigate}
              handleChange={handlePagination}
              totalData={totalEntries}
              handleSizeChangerChange={handlePaginationPageSize}
              pageSize={pageSize ?? TableDefaults.PAGESIZE}
              currentPage={currentPage}
              pageSizeOptions={[10, 25, 50, 100]}
            />
          </ConditionalRender>
        </ConditionalRender>
        <ConditionalRender visible={activeView === MAP}>
          <JobListMapView
            filters={filters}
            noActionAllowed={noActionDropFields}
            showBlocked={showBlocked}
          />
        </ConditionalRender>
      </div>
    </>
  );
};

export default JobView;
